import styled from 'styled-components';

export const Wrapper = styled.aside`
    flex: 0 0 80px;
    display: flex;
    justify-content: space-between;
`;
